// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__5y4zB","label":"Category_label__3xZ0I","content":"Category_content__2kgEV","header":"Category_header__2fNSJ","location":"Category_location__3BmWU"};